import React from 'react'
import Navbar from '../../components/Navbar/Navbar'
import PageTitle from '../../components/pagetitle/PageTitle'
import Footer from '../../components/footer/Footer'
import Scrollbar from '../../components/scrollbar/scrollbar'


const PrivacyPage = (props) => {

    return (
        <div>
            <Navbar />
            <PageTitle pageTitle={'Privacy Policy'} pagesub={'Privacy Policy'} />
            <section className="wpo-terms-section section-padding">
                <div className="container">
                    <div className="row">
                        <div className="col-lg-10 offset-lg-1">
                            <div className="wpo-terms-wrap">
                                <div className="wpo-terms-text">
                                    <h2>Privacy Policy - Marsh Events & Training Hub</h2>
                                    <p><strong>Last Updated: October 2025</strong></p>
                                    <p>At Marsh Events & Training Hub, we are committed to protecting your privacy and ensuring the security of your personal information. This Privacy Policy outlines how we collect, use, disclose, and safeguard your information when you visit our website or register for our training programs and events.</p>
                                    
                                    <h3>Information We Collect</h3>
                                    <p>We collect information that you voluntarily provide to us when you register for courses, book events, subscribe to our newsletter, or contact us. This may include:</p>

                                    <ul>
                                        <li>Personal identification information (Name, Date of Birth, Passport Number)</li>
                                        <li>Contact details (Email address, Phone number, Mailing address)</li>
                                        <li>Professional information (Job title, Company name)</li>
                                        <li>Payment and billing information for course registrations</li>
                                        <li>Feedback and testimonials you provide</li>
                                    </ul>
                                    
                                    <h3>How We Use Your Information</h3>
                                    <p>We use the information we collect for the following purposes:</p>
                                    <ul>
                                        <li>To process your course and event registrations</li>
                                        <li>To communicate with you about upcoming training programs and events</li>
                                        <li>To provide certificates and verification services</li>
                                        <li>To improve our services and website experience</li>
                                        <li>To send periodic emails regarding your bookings and our services</li>
                                        <li>To comply with legal obligations and maintain business records</li>
                                    </ul>
                                    
                                    <h3>Data Security</h3>
                                    <p>We implement appropriate security measures to protect your personal information from unauthorized access, alteration, disclosure, or destruction. However, please note that no method of transmission over the internet is 100% secure.</p>
                                    
                                    <h3>Your Rights</h3>
                                    <p>You have the right to access, update, or delete your personal information at any time. For any privacy-related inquiries or to exercise your rights, please contact us at info@marsheventsandtraininghub.com.</p>

                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <Footer />
            <Scrollbar />
        </div>

    )
}

export default PrivacyPage;